import React, { useEffect, useState } from "react";

import { Checkbox, FormControlLabel, Popover, Stack, Typography } from "@mui/material";
import { ColumnOption } from "components/DealGroupedTable/dealGroupedTable.config";
import { PromptFooter } from "components/DealGroupedTable/PromptFooter";

interface TableSettingsProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  options: ColumnOption[];
  value: string[];
  onSubmit: (result: string[]) => void;
}

export const TableSettings: React.FC<TableSettingsProps> = ({ anchorEl, open, onClose, options, value, onSubmit }) => {
  const [selected, setSelected] = useState<string[]>(value);

  // Re-sync the draft each time the popover opens.
  useEffect(() => {
    if (open) setSelected(value);
  }, [open, value]);

  const toggle = (key: string) =>
    setSelected((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));

  const handleApply = () => {
    onSubmit(selected);
    onClose();
  };

  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Stack sx={{ width: 272, p: "24px", gap: "20px" }}>
        <Typography sx={{ fontSize: "18px", lineHeight: "24px", color: "#071f35" }}>Columns</Typography>

        <Stack>
          {options.map((option) => (
            <FormControlLabel
              key={option.key}
              control={
                <Checkbox
                  checked={selected.includes(option.key)}
                  onChange={() => toggle(option.key)}
                  sx={{ p: "8px", color: "#071f35", "&.Mui-checked": { color: "#071f35" } }}
                />
              }
              label={<Typography sx={{ fontSize: "14px", color: "#071f35" }}>{option.label}</Typography>}
              sx={{ m: 0, gap: "6px" }}
            />
          ))}
        </Stack>

        <PromptFooter onCancel={onClose} onApply={handleApply} />
      </Stack>
    </Popover>
  );
};
